import { Modal as MantineModal, ModalProps, createStyles } from '@mantine/core';

const useStyles = createStyles(() => ({
  modalContainer: {
    'z-index': 9999,
  },
}));

export function Modal(props: ModalProps) {
  const { children, centered = true, size = 'auto', ...rest } = props;
  const { classes } = useStyles();

  return (
    <MantineModal
      className={` ${classes.modalContainer}`}
      size={size}
      trapFocus={false}
      centered={centered}
      {...rest}
    >
      {children}
    </MantineModal>
  );
}
